import controller from './list-preview.controller';
import template from './list-preview.html';
import './list-preview.scss';

export default {
	template,
	bindings: {
		row: '<ngModel',
		tab: '=',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
